<template>
  <div class="header-login">
    <div class="header-login-user" v-if="!loggedIn">
      <el-button link class="user-login-btn" @click="handleGoLogin">
        <el-icon><User /></el-icon>
        登录
      </el-button>
    </div>
    <el-dropdown v-else class="user-login-dropdown">
      <span class="el-dropdown-link">
        <el-icon><User /></el-icon>
        <span>{{ displayName }}</span>
        <el-icon class="el-icon--right"><ArrowDown /></el-icon>
      </span>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item v-if="isAdmin" @click="goAdmin">
            管理后台
          </el-dropdown-item>
          <el-dropdown-item @click="logout">退出</el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { User, ArrowDown } from "@element-plus/icons-vue";
import { httpAuthPost } from "@/api/httpService";
import { goLogin } from "@/core/navigation";
import {
  isLoggedIn as hasAuthCookies,
  parseUserInfoCookie,
} from "@/core/auth/token";
import { resetLoginSyncFlag } from "@/core/auth/synchronizeUserPermission";

const router = useRouter();
const store = useStore();

const loggedIn = computed(
  () => hasAuthCookies() || !!store.state.auth.localUser
);

const isAdmin = computed(() => !!store.state.auth.isAdmin);

function goAdmin() {
  router.push("/admin/graphs");
}

const displayName = computed(() => {
  const local = store.state.auth.localUser;
  if (local?.name) {
    return local.name;
  }
  const cookieUser = parseUserInfoCookie();
  return cookieUser?.name ?? cookieUser?.loginName ?? "已登录用户";
});

function handleGoLogin() {
  goLogin();
}

async function logout() {
  const userId =
    store.state.auth.localUser?.id ?? parseUserInfoCookie()?.userId ?? null;
  await httpAuthPost("/centerAuth/v1/exit", {});
  resetLoginSyncFlag(userId);
  await store.dispatch("auth/clearAuth");
  store.commit("auth/setLoginReady", true);
  goLogin();
}
</script>

<style lang="scss" scoped>
.header-login {
  display: inline-flex;
  align-items: center;
  .header-login-user {
    display: inline-flex;
    align-items: center;
    .user-login-btn {
      margin-left: 12px;
    }
  }
  :deep(.user-login-dropdown) {
    margin-left: 12px;
    .el-dropdown-link {
      display: flex;
      align-items: center;
      cursor: pointer;
      .el-icon {
        margin-right: 4px;
      }
    }
  }
}
</style>
